export default __webpack_public_path__ + "static/media/cities-big-10-white.0f42ee2b.png";